const { TEXT_HORIZONTAL_GROW } = require('./constants');

const calculateGrowDimensions = ({
    growDirection = TEXT_HORIZONTAL_GROW.CENTER,
    anchorStyle,
    metrics: { width, height }
}) => {
    const dimensions = { width, height };

    const anchor = {
        left: parseFloat(anchorStyle.left),
        width: parseFloat(anchorStyle.width)
    };

    const grow = width > anchor.width;
    const delta = Math.abs(width - anchor.width);

    let change;
    switch (growDirection) {

        // TODO - Fix this epic
        case TEXT_HORIZONTAL_GROW.RIGHT:
            change = delta;
            break;
        case TEXT_HORIZONTAL_GROW.CENTER:
            change = delta / 2;
            break;
        default:
            change = 0;
            break;
    }

    dimensions.left = grow ? (anchor.left - change) : anchor.left + change;

    return dimensions;
};

module.exports = calculateGrowDimensions;
